import { render } from "./CoursePhoto.vue?vue&type=template&id=0bd5b31c&scoped=true"
import script from "./CoursePhoto.vue?vue&type=script&lang=js"
export * from "./CoursePhoto.vue?vue&type=script&lang=js"

import "./CoursePhoto.vue?vue&type=style&index=0&id=0bd5b31c&scoped=true&lang=css"

import exportComponent from "../../../e-parent/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bd5b31c"]])

export default __exports__